import { Card, CardBody, Col, Container, Row } from 'reactstrap'
import { Wishlist } from '../../../../Utils/Constants'
import WishlistData from './WishlistData'
import CardHeaderCommon from '../../../../Utils/CommonComponents/CardHeaderCommon'

const WishListContainer = () => {
  return (
    <Container fluid>
        <Row>
            <Col sm="12">
                <Card>
                    <CardHeaderCommon title={Wishlist} />
                    <CardBody>
                        <WishlistData />
                    </CardBody>
                </Card>
            </Col>
        </Row>
    </Container>
  )
}

export default WishListContainer